// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-tax-input {
    width: 96%;
    padding: 10px 16px;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    transition: 0.3s all ease-in-out;
}
.easycommerce .easycommerce-tax-input:hover {
    border-color: var(--color-ec-secondary);
}
.easycommerce .easycommerce-tax-input:focus {
    border-color: var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);
    outline: none;
}

.easycommerce .easycommerce-tax-select {
    width: 98%;
    max-width: 100%;
    display: block;
    color: var(--color-ec-placeholder);
    padding: 10px;
    font-family: "Inter", "sans-serif";
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
    transition: 0.3s all ease-in-out;
}
.easycommerce .easycommerce-tax-select:hover {
    border-color: var(--color-ec-secondary);
    color: var(--color-ec-body);
}
.easycommerce .easycommerce-tax-select:focus {
    color: var(--color-ec-primary);
    border: 1px solid var(--color-ec-primary);
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);
    outline: none;
}
.easycommerce .easycommerce-tax-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
    font-size: 14px;
    line-height: 16px;
}
.easycommerce .easycommerce-tax-input::placeholder {
    color: var(--color-ec-placeholder);
    font-size: 14px;
    line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/tax/src/assets/css/tax.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,qCAAqC;IACrC,sDAAsD;IACtD,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd,kCAAkC;IAClC,aAAa;IACb,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,kBAAkB;IAClB,gCAAgC;AACpC;AACA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;AACA;IACI,8BAA8B;IAC9B,yCAAyC;IACzC,sDAAsD;IACtD,aAAa;AACjB;AACA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;AAJA;IACI,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".easycommerce .easycommerce-tax-input {\n    width: 96%;\n    padding: 10px 16px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce .easycommerce-tax-input:hover {\n    border-color: var(--color-ec-secondary);\n}\n.easycommerce .easycommerce-tax-input:focus {\n    border-color: var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);\n    outline: none;\n}\n\n.easycommerce .easycommerce-tax-select {\n    width: 98%;\n    max-width: 100%;\n    display: block;\n    color: var(--color-ec-placeholder);\n    padding: 10px;\n    font-family: \"Inter\", \"sans-serif\";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 26px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n    transition: 0.3s all ease-in-out;\n}\n.easycommerce .easycommerce-tax-select:hover {\n    border-color: var(--color-ec-secondary);\n    color: var(--color-ec-body);\n}\n.easycommerce .easycommerce-tax-select:focus {\n    color: var(--color-ec-primary);\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);\n    outline: none;\n}\n.easycommerce .easycommerce-tax-input::placeholder {\n    color: var(--color-ec-placeholder);\n    font-size: 14px;\n    line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
